import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c4a7250e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4a7250e')) {
      api.createRecord('c4a7250e', component.options)
    } else {
      api.reload('c4a7250e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c4a7250e", function () {
      api.rerender('c4a7250e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pattern/components/scene-manage/index.vue"
export default component.exports